import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AccountProfile from "@/pages/account/AccountProfile";

export const Route = createFileRoute("/account/")({
  head: () => pageHead("Account \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AccountProfile,
});
